"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticDateDecoratorOrNull = exports.reactiveDateDecoratorOrNull = void 0;
var _serializr = require("serializr");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _reactive_date_decorator = _interopRequireDefault(require("../reactive_date_decorator"));
var _static_date_decorator = _interopRequireDefault(require("../static_date_decorator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// reminder to not import AppUI to avoid circular dependencies

/**
 * Creates a serializr custom deserializer for StaticDateDecorator fields.
 * Returns null if the item is not present, otherwise creates a StaticDateDecorator.
 * This is the lightweight version without MobX observables.
 *
 * @returns {function} A serializr custom deserializer
 *
 * @example
 * @observable @serializable(staticDateDecoratorOrNull()) publishedAt;
 */
var staticDateDecoratorOrNull = exports.staticDateDecoratorOrNull = function staticDateDecoratorOrNull() {
  return (0, _serializr.custom)(_lodash.noop, function (item) {
    return (0, _utils.isPresent)(item) ? new _static_date_decorator["default"](item) : null;
  });
};

/**
 * Creates a serializr custom deserializer for ReactiveDateDecorator fields.
 * Returns null if the item is not present, otherwise creates a ReactiveDateDecorator.
 * This uses MobX observables and is more memory intensive.
 *
 * @returns {function} A serializr custom deserializer
 *
 * @example
 * @observable @serializable(reactiveDateDecoratorOrNull()) publishedAt;
 */
var reactiveDateDecoratorOrNull = exports.reactiveDateDecoratorOrNull = function reactiveDateDecoratorOrNull() {
  return (0, _serializr.custom)(_lodash.noop, function (item) {
    return (0, _utils.isPresent)(item) ? new _reactive_date_decorator["default"](item) : null;
  });
};